import React, { useState } from 'react'
import leftMenu from '../../Images/leftMenu.png'
import closeMenu from '../../Images/closeMenu.png'
import Banner from '../../Images/Banner.png'
import telephone from '../../Images/telephone.png'
import book from '../../Images/book.png'
import locationimg from '../../Images/location.png'
// import Logo from '../../Images/Logo.png'
import './Header.scss';
import Arrow from '../../Images/downArrow.png'
import { useLocation, useNavigate } from 'react-router-dom'

export default function Header({ CitiePhone, CitiesData, showMenu, setShowPopUp, setShowMenu }) {
    const [header, setHeader] = useState(false)
    const location = useLocation()
    const navigate = useNavigate()
    return (
        <div className="Header">
            {/* HeaderBottom */}
            <div className="HeaderBottom">
                <div className='Header2'>
                    <div className="Header2Location">
                        <img src={require(`../../Images/place.png`)} alt="" />
                        <h1>{CitiesData.City ? CitiesData.City.toUpperCase() : "Local"}</h1>

                    </div>

                </div>
                <div className="Header1Main">
                    <div className="Header2Circle">
                        <div className='circle'>
                            <span className='hdhs1'></span>
                            <span className='hdhs2'></span>
                        </div>
                        <h3>We Are Open</h3>
                    </div>
                    <div className='Header1'>
                        <a href='#book'>SCHEDULE <span>&nbsp;ONLINE</span><img src={book} alt="Air Duct Cleaning | Air Duct Repair | Air Duct Services | Air Duct Inspection In Master," /></a>
                    </div>
                    <div className='Header1'>
                        <a target='_blank' href={`tel:${CitiePhone}`}>CALL <span>&nbsp;{CitiePhone}</span><img src={telephone} alt="Air Duct Cleaning | Air Duct Repair | Air Duct Services | Air Duct Inspection In Master," /></a>
                    </div>
                </div>
            </div>
            <div className="HeaderBottom2">
                <a target='_blank' href={`tel:${CitiePhone}`}>866-257-5796  |  Call AttiAir to Book Your Service</a>
                <img src={require(`../../ImagesLogos/logobanner.png`)} alt="" />

            </div>
        </div>
    )
}
